import { render, staticRenderFns } from "./AccountProfileForm.vue?vue&type=template&id=5fbe3278"
import script from "./AccountProfileForm.vue?vue&type=script&lang=js"
export * from "./AccountProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports